module.exports = {
  SERVER_URL: `${process.env.REACT_APP_HOST}`,

  // SERVER_URL: `http://127.0.0.1:1221`,
}